<template>
  <div class="main_content">
    <div class="breadcrumbs" />
    <div v-if="!loading" class="help">
      <config-bar class="help_bar" />
      <v-sheet
        class="help_main"
        :class="{ ['help_full-height']: routeName === 'help-cam-select' }"
      >
        <router-view></router-view>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import ConfigBar from '@/views/help/ConfigBar.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Help',
  components: {
    ConfigBar,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
    }),
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route: {
      handler: function (to, from) {
        this.handleRouteChange(to, from);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('common', ['setIsLoading']),
    ...mapActions('help', [
      'fetchHelpInquiries',
      'setAllowCam',
      'setTopicInput',
    ]),
    ...mapActions('settings', ['fetchUserAvatarList']),
    handleRouteChange(to, from) {
      if (from?.name === 'help-cat' && to?.name === 'help-cat-list') {
        this.setAllowCam(false);
        this.setTopicInput({
          input: null,
          categoryId: this.$route.params.id,
          topicId: this.$route.params.topic,
        });
      }
      if (!from) {
        this.init();
      } else if (!this.$route.params.id) {
        this.routerPush({
          name: 'help-cat',
          params: { id: this.helpCategories[0].id },
        });
      }
    },
    async init() {
      this.loading = true;
      try {
        this.setIsLoading(true);
        await this.fetchUserAvatarList();
        await this.fetchHelpInquiries();
        if (!this.$route.params.id) {
          this.routerPush({
            name: 'help-cat',
            params: { id: this.helpCategories[0].id },
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.setIsLoading(false);
      }
    },
  },
};
</script>

<style lang="scss">
.help {
  display: flex;
  justify-content: space-between;
  flex: 1;
  &_main {
    height: fit-content;
    margin-left: 32px;
    width: calc(100% - 372px);
    min-width: 500px;
  }
  &_full-height {
    height: 100%;
  }
  &_bar {
    display: flex;
    flex-direction: column;
    width: 340px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}
</style>
